module.exports = __webpack_public_path__ + "img/MW_Groups_FB_Instructions_2.5801337e.gif";